import Index from 'src/components/settings/users/Index';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Users = () => {
  return (
    <>
      <Typography
        fontSize={'20px'}
        fontWeight={500}
        color={'primary.dark'}
        mt={'18px'}
        mb={'16px'}
      >
        ユーザー
      </Typography>
      <Stack direction={'row'} spacing={'20px'} width={'auto'}>
        <Index />
      </Stack>
    </>
  );
};

export default Users;
